<template>
  <div class="advancedSearch w100">
    <!--  高级搜索 -->
    <div class="cp advancedBtn fz-m">
      <slot name="searchHeader"></slot>
      <el-popover v-if="isShowMore" popper-class="advancePopver" placement="bottom" width="900" trigger="click">
        <!-- slot 筛选条件插槽 -->
        <div class="flex_end_center">
          <el-button class="mg_10_0" type="default" size="mini" @click="clearQuery">清空</el-button>
        </div>
        <slot name="searchList"></slot>
        <div slot="reference" class="mg_0_10 cp ">
          <el-button type="default" size="mini" class="filter-item" icon="el-icon-arrow-down"/>
        </div>
      </el-popover>
      <slot name="searchButton"></slot>
    </div>
    <slot name="descriptor"></slot>
  </div>

</template>

<script>
export default {
  name: 'AdvancedSearch',
  props: {
    // 搜索项
    listQuery: {
      type: Object
    },
    // 弹框内搜索项
    advancedSearchQuery: {
      type: Object
    },
    // 不监听项
    isNoCheck: {
      type: String,
      default: 'page_no,page_size,order_by,direction'
    },
    // 弹框外的搜索项
    externalSearchItem: {
      type: String
    },
    // 是否展示更多搜索项的下拉按钮
    isShowMore: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      isShowResult: false
    }
  },
  watch: {
    listQuery: {
      // 监听筛选项有没有值变更
      // handler(newValue, oldValue) {
      //   this.isShowResult = false;
      //   for (const key in this.listQuery) {
      //     if (this.listQuery.hasOwnProperty(key)) {
      //       const element = this.listQuery[key];
      //       if (this.isNoCheck.indexOf(key) < 0) {
      //         if (element !== undefined || element !== "" || element !== null) {
      //           this.isShowResult = true;
      //         }
      //       }
      //     }
      //   }
      // }
    }
  },
  mounted() {},
  methods: {
    // 打开高级搜索框
    openDialog() {
      this.dialogFormVisible = true
      this.$emit('openDialog')
    },
    // 清空搜索项
    emptySearch() {
      const searchForm = Object.assign({}, this.listQuery)
      for (const key in searchForm) {
        if (searchForm.hasOwnProperty(key)) {
          const element = searchForm[key]
          if (this.isNoCheck.indexOf(key) < 0) {
            delete searchForm[key]
          }
        }
      }
      this.$emit('emptySearch', searchForm)
    },
    // 点击取消关闭弹窗,不做渲染
    closeDialog() {
      this.dialogFormVisible = false
    },
    // 清空弹框外的字段，并提交
    submitQuery() {
      this.closeDialog()
      const searchForm = Object.assign({}, this.advancedSearchQuery)
      for (const key in searchForm) {
        if (searchForm.hasOwnProperty(key)) {
          const element = searchForm[key]
          if (this.externalSearchItem.indexOf(key) > -1) {
            delete searchForm[key]
          }
        }
      }
      this.$emit('submitQuery', searchForm)
    },
    clearQuery() {
      // this.$emit("update:listQuery", newVal);
      this.$emit('clearQuery')
      // this.handleFilter();
    }
  }
}
</script>

<style lang="scss">
.advancedSearch {
  display: inline;
}
.searchHeader {
  display: flex;
}
.searchHeader .el-select,
.searchHeader .el-input,
.searchHeader .el-date-editor {
  margin: 0 5px 0 0;
}
.searchButton{
  margin: 0 0 0 5px ;
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
}
.advancedBtn {
  display: flex;
  margin: -10px 0 -20px 0;
  flex-wrap: wrap;
}
.advancedBtn .mg_0_10 {
  margin: 0 0 0 10px;
}
.advancedBtn:hover {
  color: #4d939f;
}
.advancePopver .el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}
.advancePopver .filter-container .filter-item {
  margin-bottom: 0;
}
.descriptor{
  margin: 30px 0 10px 0;
}
</style>
